/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

document.addEventListener('variant:changed', function(event) {
  var variant = event.detail.variant; // Gives you access to the whole variant details
  console.log("variant",variant);
});

 //Pad Creative Custom JS
    console.log("Pad Creative custom JS in main-product.liquid 2212051308");
    let shtTpBtns = [];
    window.onload = (event) => {
      // console.log("page is fully loaded");
      shtTpBtns = document.querySelectorAll('input[name="properties[Shirt type]"],input[name="properties[Tipo della camicia]"]');
      // console.log("shtTpBtns",shtTpBtns);
      shtTpBtns.forEach(function(btn){
        // console.log("btn",btn);
        btn.addEventListener("click",function(e){
            // console.log("click event",e);
            document.querySelectorAll(".custom.show").forEach((lnk) => {lnk.classList.remove("show")});
            const shtTp=e.target.value;
              if(shtTp=="Custom"){
                document.querySelectorAll(".custom").forEach((lnk) => {lnk.classList.add("show")});
              }
        });
      });
      document.querySelectorAll(".size-guide a").forEach((link) => {
        link.addEventListener("click",(e)=>{
          e.preventDefault();
          console.log("link",e);
          // alert("We do not have the graphics for this item yet. When we do, we will pop-up a window showing "+e.target.innerHTML);
          const popImg=e.target.href;
          createModal(popImg);
        });
      });
      //! THIS DOES NOT WORK: THE EVENT IS NOT ATTACHED TO THE BUTTON:
      // const addToCart = document.querySelector('button[data-action="add-to-cart"]') || false;
      // if(addToCart) {
      //   console.log("Add to cart button",addToCart);
      //   addToCart.addEventListener("click",e => {
      //     console.log("Add to cart button clicked",e);
      //   });
      // }

      //* THIS WORKS, BUT REQUIRES POINTEREVENTS: NONE ON BUTTON (POSES A UX RISK!!)
      const addToCartBtnContainer = document.querySelector(".ProductForm__BuyButtons") || false;
      if(addToCartBtnContainer) {
        // console.log("Adding event tracking fallback");
        // addToCartBtnContainer.addEventListener("mouseenter",attachTrackingToCartButton);
        addToCartBtnContainer.addEventListener("click",(e) => {
          console.log("Add to cart container clicked",e,trackingFallback);
          dataLayer.push({ 'ecommerce': null });
          dataLayer.push(trackingFallback); 
          const addToCart=e.target.querySelector('button[data-action="add-to-cart"]');
          console.log("Add to cart button",addToCart);
          addToCart.click();
        });
      }

      //! ATTEMPTING TO ATTACH EVENT BASED ON PARENT MOUSEENTER. STILL CAN"T ATTACH CLICK EVENT DIRECTLY TO BUTTON...
      // function attachTrackingToCartButton(el){
      //   console.log("attachTrackingToCartButton",el, this);
      //   const addToCart=this.querySelector('button[data-action="add-to-cart"]');
      //   console.log("Add to cart button",addToCart);
      //   addToCart.addEventListener("click",e => {
      //     console.log("Add to cart button clicked",e,trackingFallback);
      //     dataLayer.push({ 'ecommerce': null });
      //     dataLayer.push(trackingFallback); 
      //   })
      //   addToCartBtnContainer.removeEventListener("mouseenter",attachTrackingToCartButton);
      // }
    };

  function createModal(popImg){
          console.log("popImg",popImg);
    const modal = document.createElement("div");
          modal.id="padModal";
    const close = document.createElement("span");
          close.innerHTML="X";
          close.addEventListener("click",function(){
            document.getElementById("padModal").remove();
          });
          modal.append(close);
    const media = document.createElement("img");
          media.src=popImg;
          modal.append(media);
    document.body.prepend(modal);
  }

 jQuery(function($){
    console.log("Pad Dev jQuery Init",$().jquery);

   //Relentless Apps Product Variants Tracking Work-around:
   $(document).on('bcpo:add', function (e) {
    console.log("Add to cart container clicked",e,trackingFallback);
          dataLayer.push({ 'ecommerce': null });
          dataLayer.push(trackingFallback); 
  });
   $(".ProductForm").on("change","input,select,textarea",function(){
    window.Klarna.OnsiteMessaging.refresh();
   });
 });
  
  // e/o Pad Creative Custom JS

